import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../hooks/use-auth";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Card,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery 
} from "@mui/material";
import CustumerDetailsDraggableDrawer from ".././../../components/dashboard/customer/custumer_detail_draggable_drawer.js";
import colors from './../../../theme/colors.js';
import LinkIcon from "@mui/icons-material/Link";
import { Scrollbar } from "../../../components/scrollbar";
import { useMounted } from "../../../hooks/use-mounted";
import { userApi } from "../../../api/user-api";
import SearchIcon from "@mui/icons-material/Search";
import BlockIcon from '@mui/icons-material/Block';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Avatar from '@mui/material/Avatar';

const Customers = (props) => {
  const isMounted = useMounted();
  const {
    customersCount,
    onPageChange,
    onRowsPerPageChange,
    page,
    rowsPerPage,
    ...other
  } = props;

  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [match, setMatch] = useState(false);
  const [pagin, setPagin] = useState(0);
  const [totalNumberOfUsers, setTotalNumberOfUsers] = useState(0);
  const [limit, setLimit] = useState(25);
  const [permissions, setPermissions] = useState([]);
  const isMobile = useMediaQuery('(max-width:800px)');


  const { user } = useAuth();

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPagin(0);
    handleCustomers(searchName,pagin,parseInt(event.target.value, 10));
  };

  const handlePageChange = (event, newPage) => {
    setPagin(newPage);
    handleCustomers(searchName,newPage,limit);
  };
  const getPermissionsByRole = async (roles_id) => {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/permission-verification/get/`;
    const values = { roles_id };
    const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);

    try {
      const resp = await fetch(url, {
        method: "POST",
        body: JSON.stringify(values),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!resp.ok) {
        throw new Error(`HTTP error! Status: ${resp.status}`);
      }

      const json = await resp.json();
      setPermissions(json.permissions);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  // Vérifie si l'utilisateur a la permission "Voir" pour "Apprenants"
  const hasViewApprenantsPermission = () => {
    return permissions.some(
      (permission) =>
        permission.component === "Apprenants" && permission.permission === "Voir"
    );
  };

  // Récupérer les permissions lorsque le composant est monté
  useEffect(() => {
    if (user && user.roles_id) {
      getPermissionsByRole(user.roles_id);
    }
  }, [user]);

  const getCustomers = useCallback(async () => {
    try {
      const data = await userApi.getUsers(user.admin_id, pagin, limit);
      if (isMounted()) {
        setCustomers(data.users);
        setTotalNumberOfUsers(data.users_number);
      }
    } catch (err) {
      console.error(err);
    }
  }, [isMounted]);

  const handleCustomers = useCallback(async(searchName,pagin,limit) => {
    try {
      const data = await userApi.searchUsers(
        user.admin_id,
        searchName,
        pagin,
        limit
      );
      if (data.search_results.length > 0) {
        setCustomers(data.search_results);
        setTotalNumberOfUsers(data.users_number);
        setMatch(true);
      }else{
        setMatch(false)
      }
    } catch (err) {
      console.error(err);
    }
  });

  useEffect(() => {
    if (searchName.length >= 3) {
      setPagin(0);
      handleCustomers(searchName,0,limit);
    }
  }, [searchName]);

  useEffect(() => {
    getCustomers();
  }, [getCustomers]);

  useEffect(() => {
    if (hasViewApprenantsPermission()) {
      getCustomers();
    }
  }, [getCustomers, permissions]);

  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 11,
        }}
      >
  
        <Container maxWidth="x1">
             
          <Box sx={{ mb: 5 }}>
            <Grid container justifyContent="space-between" spacing={3}>
              <Grid item>
                <Typography variant="h4" sx={{fontFamily: "Montserrat"}}>Apprenants</Typography>
              </Grid>
            </Grid>
          </Box>
          {hasViewApprenantsPermission() ? (
            <Card>
              <Divider />
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexWrap: "wrap",
                  m: -1,
                  p: 3,
                }}
              >
                <Box
                  sx={{
                    m: 1,
                    maxWidth: "100%",
                    width: 450,
                  }}
                >
                  <TextField
                    value={searchName}
                    onChange={(e) => setSearchName(e.target.value)}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                    placeholder="Chercher un apprenant"
                  />
                </Box>
              </Box>
              <Scrollbar>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ p: 2 }}>
                        <Typography
                          sx={{ mx: 3 }}
                          fontWeight="Bold"
                          fontSize={13}
                        >
                          Nom
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ p: 2 }}>
                        <Typography
                          sx={{ mx: 3 }}
                          fontWeight="Bold"
                          fontSize={13}
                        >
                          Email
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ p: 2 }}>
                        <Typography
                          sx={{ mx: 3 }}
                          fontWeight="Bold"
                          fontSize={13}
                        >
                          TLMS
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ p: 2 }}>
                        <Typography
                          sx={{ mx: 3 }}
                          fontWeight="Bold"
                          fontSize={13}
                        >
                          Syndays
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ p: 2 }}>
                        <Typography
                          sx={{ mx: 3 }}
                          fontWeight="Bold"
                          fontSize={13}
                        >
                          Feedback
                        </Typography>
                      </TableCell>

                      {!isMobile && <TableCell sx={{ p: 2 , display: "flex", justifyContent: "center"}}>
                        <Typography
                          sx={{ mx: 3 }}
                          fontWeight="Bold"
                          fontSize={13}
                        >
                          Vue rapide
                        </Typography>
                      </TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {customers.map((customer) => (
                      <TableRow hover key={customer.id}>
                        <TableCell>
                          <Box
                            sx={{
                              alignItems: "center",
                              display: "flex",
                            }}
                          >
                            <Box sx={{ ml: 2 }}>
                             
                            
        <RouterLink
          to={`/${globalThis.localStorage.getItem('tenant')}/dashboard/customers/${customer.id}`}
          style={{ textDecoration: "none" }}
        >
          <Typography
          color={(theme) =>
            theme.palette.mode === "dark"
              ? colors.secondary
              : colors.primary
          }
          fontWeight="Bold"
          fontSize={14}
        >
            {customer.firstname} {customer.lastname}
          </Typography>
        </RouterLink>
      
                            </Box>
                          </Box>
                        </TableCell>

                        <TableCell>
                          <Box
                            sx={{
                              alignItems: "center",
                              display: "flex",
                              // p: 0,
                            }}
                          >
                            <Box sx={{ ml: 1 }}>
                              <Typography
                                color={(theme) =>
                                  theme.palette.mode === "dark"
                                    ? "#F5F6FC"
                                    : colors.primary
                                }
                                fontSize={15}
                              >
                                {customer.email}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              alignItems: "center",
                              display: "flex",
                            }}
                          >
                            <Box sx={{ ml: 3 }}>
                              {customer.tlms_id ? (
                                <IconButton
                                 href={`https://${customer.tlms_domain}/user/info/id:${customer.tlms_id}`}
                                  target="_blank"
                                >
                                  <LinkIcon fontSize="small" />
                                </IconButton>
                              ) : (
                                " "
                              )}
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              alignItems: "center",
                              display: "flex",
                            }}
                          >
                            <Box sx={{ ml: 3 }}></Box>
                            <IconButton
                             href={`https://${globalThis.localStorage.getItem('tenant')}.syndays.fr/dashboard/customers/${customer.syna_id}`}
                              target="_blank"
                            >
                              <LinkIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                        
                      <TableCell align="center">
                          <Box>
                            {(customer.options.feedback_state === "à venir" ||
                              (customer.options.feedback_state ===
                                "En attente" &&
                                customer.options.nb_courses === 0)) && (
                              <>
                                <Tooltip title={`à venir`}>
                                  <Avatar
                                    sx={{
                                      backgroundColor: "white",
                                      marginLeft: 5,
                                    }}
                                  >
                                    <BlockIcon
                                      sx={{ color: "grey", fontSize: 30 }}
                                    />
                                  </Avatar>
                                </Tooltip>
                              </>
                            )}
                            {customer.options.feedback_state === "En attente" &&
                              customer.options.nb_courses !== 0 && (
                                <>
                                  {customer.options.nb_courses === 1 ? (
                                    <Tooltip
                                      title={`${customer.options.nb_courses} feedback`}
                                    >
                                      <Avatar
                                        sx={{
                                          backgroundColor: "white",
                                          marginLeft: 5,
                                        }}
                                      >
                                        <HourglassTopRoundedIcon
                                          sx={{
                                            color: "#FF8C00",
                                            fontSize: 30,
                                          }}
                                        />
                                      </Avatar>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip
                                      title={`${customer.options.nb_courses} feedbacks`}
                                    >
                                      <Avatar
                                        sx={{
                                          backgroundColor: "white",
                                          marginLeft: 5,
                                        }}
                                      >
                                        <HourglassTopRoundedIcon
                                          sx={{
                                            color: "#FF8C00",
                                            fontSize: 30,
                                          }}
                                        />
                                      </Avatar>
                                    </Tooltip>
                                  )}
                                </>
                              )}
                            {customer.options.feedback_state === "finis" && (
                              <>
                                <Tooltip title={`finis`}>
                                  <Avatar
                                    sx={{
                                      backgroundColor: "white",
                                      marginLeft: 5,
                                    }}
                                  >
                                    <CheckCircleIcon
                                      sx={{ color: "green", fontSize: 30 }}
                                    />
                                  </Avatar>
                                </Tooltip>
                              </>
                            )}
                          </Box>
                        </TableCell>
                        {!isMobile && 
                       <TableCell> <Box     sx={{
                        alignItems: "center",
                        display: "flex",
                        alignContent: "center",
 height:"100%", width:"100%",
                        // p: 0,
                      }}> <CustumerDetailsDraggableDrawer 
                        customer_id={customer.id} 
                        customer_name={`${customer.firstname} ${customer.lastname}`} 
                      /></Box></TableCell>}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Scrollbar>
              <TablePagination
                component="div"
                count={totalNumberOfUsers}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={pagin}
                labelRowsPerPage="Lignes par page :"
                rowsPerPage={limit}
                rowsPerPageOptions={[25, 50, 100]}
              />
            </Card>
          ) : (!match ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              padding={5}
            >
              <Typography color="inherit" size={150} />
            </Box>
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              padding={5}
            >
              <CircularProgress color="inherit" size={150} />
            </Box>
          ))}
        </Container>
      </Box>
    </>
  );
};

export default Customers;
